module.exports = __webpack_public_path__ + "img/discord-icon.3041e839.svg";